export default __webpack_public_path__ + "static/Stanislaw_Szultka-64fa5aade39a24077820a31f20f90eca.jpg";